import $ from 'jquery';

function initCollapseControl() {
  $(".collapse_expand_all_card").click(function(e) {
    var card_total = $('[id^="activity_card_"]').length;
    var collapse = $('.fa.fa-minus');
    var expand = $('.fa.fa-plus');
    if (expand.length > 0) {
      expand.click();
    } else {
      collapse.click();
    }
  });
}

export default initCollapseControl;
